<template>
  <div class="info">
    <div class="info-herder">
      <slot name="title"></slot>
    </div>
    <div class="item">
      <!--item -->
      <div class="item-info" v-for="(item, index) in dataList" :key="index">
        <div class="item-info-herder">
          <p class="title">
            <router-link :to="{path:'/infoDetails',query:{id:item.id}}" class="titleLink" target="_blank">
              {{ item.title }}
            </router-link>
          </p>
          <p class="time">{{ item.publishTime }}</p>
        </div>
        <div class="item-info-main">
          <router-link :to="{path:'/infoDetails',query:{id:item.id}}" class="link" target="_blank">
            {{ item.word }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped lang="less">
.info {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  .info-herder {
    text-align: center;
    p {
      color: #989898;
      font-size: 16px;
      margin-bottom: 0px;
    }
    h3 {
      margin-top: 10px;
      color: #676767;
      font-size: 24px;
    }
  }
  .item {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .item-info {
      width: 45%;
      border-bottom: 1px solid #c9c3c3;
      .item-info-herder {
        display: flex;
        justify-content: space-between;
        .title {
          .titleLink {
            text-decoration: none;
            display: block;
            width: 360px;
            font-size: 16px;
            color: #2b2b2b;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:hover {
               color: #e95732;;
            }
          }
        }
        .time {
          color: #ccc;
          font-size: 14px;
          vertical-align: middle;
        }
      }
      .item-info-main {
        width: 90%;
        padding-bottom: 20px;
        .link {
          color: #7a7a7a;
          font-weight: 500;
          font-size: 14px;
          outline: none;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-decoration: none;
          /*鼠标划过(停留)的链接*/
          &:hover {
            color: #e95732;;
          }
        }
      }
    }
  }
}
</style>
